export default __webpack_public_path__ + "static/media/40.1d15d951.jpeg";